{
  "version": 1,
  "asset_id": "3c9cf676-0b7d-4989-9846-a237911423ed",
  "project_id": "81864b6f-53ca-42c2-811b-21ffcbfd0515",
  "url": "/__l5e/assets-v1/3c9cf676-0b7d-4989-9846-a237911423ed/achabs.webp",
  "r2_key": "a/v1/81864b6f-53ca-42c2-811b-21ffcbfd0515/3c9cf676-0b7d-4989-9846-a237911423ed/achabs.webp",
  "original_filename": "achabs.webp",
  "size": 35454,
  "content_type": "image/webp",
  "created_at": "2026-07-13T07:02:44Z"
}
